export default "__VITE_ASSET__BzUGjBd___"